import { apiDelete, apiGet, apiPatch, apiPost } from "./client";
import type {
  AdminMeResponse,
  AdminProfile,
  AdminSite,
  AdminSiteCreate,
  AdminSiteUpdate,
} from "@/types";

export function getAdminMe(): Promise<AdminMeResponse> {
  return apiGet<AdminMeResponse>("/admin/me");
}

export function postAdminLogin(username: string, password: string): Promise<AdminMeResponse> {
  return apiPost<AdminMeResponse>("/admin/login", { username, password });
}

export function postAdminLogout(): Promise<void> {
  return apiPost<void>("/admin/logout", {});
}

export function getAdminProfiles(): Promise<AdminProfile[]> {
  return apiGet<AdminProfile[]>("/admin/profiles");
}

export function getAdminSources(
  profileSlug: string,
  includeInactive = true,
): Promise<AdminSite[]> {
  const params = new URLSearchParams({
    profile_slug: profileSlug,
    include_inactive: String(includeInactive),
  });
  return apiGet<AdminSite[]>(`/admin/sources?${params}`);
}

export function createAdminSource(body: AdminSiteCreate): Promise<AdminSite> {
  return apiPost<AdminSite>("/admin/sources", body);
}

export function updateAdminSource(siteId: number, body: AdminSiteUpdate): Promise<AdminSite> {
  return apiPatch<AdminSite>(`/admin/sources/${siteId}`, body);
}

export function deleteAdminSource(siteId: number, mode: "soft" | "hard" = "soft"): Promise<void> {
  return apiDelete(`/admin/sources/${siteId}?mode=${mode}`);
}
